import { RootState } from '@/store'

export const getCustomConnector = (state: RootState) => {
  return state.spaceConnectorLogsPage ? state.spaceConnectorLogsPage.customConnector : null
}

export const getConnectorLogs = (state: RootState) => {
  return (state.spaceConnectorLogsPage && state.spaceConnectorLogsPage.logs) || []
}

export const getTotalCount = (state: RootState) => {
  return state.spaceConnectorLogsPage && state.spaceConnectorLogsPage.totalResults
    ? state.spaceConnectorLogsPage.totalResults.value || state.spaceConnectorLogsPage.totalResults
    : 0
}

export const getOffset = (state: RootState) => {
  return (state.spaceConnectorLogsPage && state.spaceConnectorLogsPage.offset) || 0
}
